/** Lowercase host without port; strips leading www. so apex and www match. */
export function canonicalSiteHost(raw?: string | null): string {
  let h = String(raw || "").trim().toLowerCase();
  if (!h) return "";
  h = h.split("/")[0].split(":")[0];
  if (h.startsWith("www.")) h = h.slice(4);
  return h;
}

export function siteHostsMatch(a?: string | null, b?: string | null): boolean {
  const ca = canonicalSiteHost(a);
  const cb = canonicalSiteHost(b);
  if (!ca || !cb) return true;
  return ca === cb;
}
